import React, { useState } from "react";
import { DateTime } from "luxon";
import FormViewer from "../../common/FormGenerator/FormViewer";
import FormViewerPdf from "../../common/FormGenerator/FormViewerPdf";
import { Disclosure } from "../../common/Fiche";
import ForceSynchroFTButton from "./ForceSynchroFTButton";
import RelanceRDOButton from "./RelanceRDOButton";
import SynchroFTStatus from "./SynchroFTStatus";

// Historique des RDO : accordéon React (un RDO déplié à la fois, comme
// l'ancien accordéon Bootstrap), mêmes actions et mêmes data-priv.
const RecipientRdoHistory = ({ rdsps = [], recipient, onAddRdsp, onSynchroForced = () => {} }) => {
  const [openId, setOpenId] = useState(null);
  const [showDl, setShowDl] = useState(false);

  return (
    <div className="rdo-history">
      <div className="py-2">
        <RelanceRDOButton allocataireId={recipient.id} />
      </div>
      {rdsps.map((r, rk) => {
        const id = r.id || r._id || `rdsp-${rk}`;
        const isV2 = r.version === 2;
        return (
          <Disclosure
            key={id}
            id={`rdsp-${id}`}
            title={"RDO du " + DateTime.fromISO(r.createdAt).toFormat("dd/MM/yyyy")}
            open={openId === id}
            onToggle={() => setOpenId(openId === id ? null : id)}
            summary={isV2 ? <SynchroFTStatus categorie="RDO" entiteId={r._id || r.id} /> : null}
          >
            <div className="d-flex align-items-center justify-content-end flex-wrap" style={{ gap: 6 }}>
              {isV2 && (
                <ForceSynchroFTButton
                  categorie="RDO"
                  entiteId={r.id}
                  label="Resynchroniser ce RDO"
                  onSuccess={onSynchroForced}
                />
              )}
              <button type="button" className="btn btn-sm btn-ghost" onClick={() => setShowDl(id)}>
                <i className="fa fa-file-pdf-o mr-2" aria-hidden="true" />
                Télécharger en PDF
              </button>
            </div>
            {showDl === id && <FormViewerPdf form={r.config} answers={r.rdsp} recipient={recipient} />}
            <FormViewer form={r.config} answers={r.rdsp} />
          </Disclosure>
        );
      })}
      {rdsps.length === 0 && (
        <div className="mt-2" data-priv="create_rdsp">
          <span style={{ fontSize: 12 }}>
            Si l'allocataire ne possède encore aucun RDO, vous pouvez en créer un manuellement
          </span>
          <button type="button" className="btn btn-primary mt-2 d-center" onClick={() => onAddRdsp(false)}>
            <i className="fa fa-plus mr-2" aria-hidden="true" />
            Ajouter un nouveau RDO
          </button>
        </div>
      )}
    </div>
  );
};

export default RecipientRdoHistory;
